import React, {useRef} from "react";

const SlidingTab = ({menuArr, selectedInd, setIndex, children, sibling}) => {
    const menuRef = useRef(null);

    const setMenuStyleProp = (ev) => {
        menuRef.current.style.setProperty('--underline-width', `${ev.target.offsetWidth}px`);
        menuRef.current.style.setProperty('--underline-offset-x', `${ev.target.offsetLeft - ev.target.parentNode.offsetLeft}px`);
    }

    const getMenus = () => {
        return menuArr.map((menu, ind) => {
            return (<span key={ind}
                className={`px-2 sub-title sliding-menu-text ${selectedInd === ind ? "sliding-menu-selected" : ""}`}
                onClick={(ev) => {
                    setIndex(ind);
                    setMenuStyleProp(ev)
                }}>{menu}</span>);
        });
    }

    return (
        <div className="p-2 ps-0 d-flex flex-column">
            <div className="d-flex justify-content-between">
                <div>
                    <div>
                        {getMenus()}
                    </div>
                    <div ref={menuRef} className={"sliding-menu"}/>
                </div>
                {sibling}
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}

export default SlidingTab;
